const capabilities = [
  {
    title: 'iOS Platform Engineering',
    description:
      'Deep specialization in the iOS ecosystem, building native solutions that leverage the full capabilities of the platform while maintaining exceptional performance and user experience.',
    icon: 'ri-smartphone-line',
  },
  {
    title: 'Clean Architecture',
    description:
      'Systems designed with clear separation of concerns, modular component structures, and well-defined interfaces that enable long-term maintainability and straightforward evolution.',
    icon: 'ri-stack-line',
  },
  {
    title: 'Performance Optimization',
    description:
      'Rigorous attention to efficiency at every layer of the stack, from rendering performance and memory management to network utilization and battery impact.',
    icon: 'ri-flashlight-line',
  },
  {
    title: 'User-Centered Design',
    description:
      'Solutions built around real human needs, with interfaces that are intuitive, accessible, and thoughtfully crafted to deliver seamless experiences across all contexts.',
    icon: 'ri-user-heart-line',
  },
  {
    title: 'Technical Quality Assurance',
    description:
      'Comprehensive testing strategies, automated verification pipelines, and systematic code review practices that ensure reliability and catch issues before they reach users.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Scalable System Design',
    description:
      'Architectures engineered for growth, with data models, API contracts, and infrastructure patterns that gracefully accommodate increasing complexity and demand.',
    icon: 'ri-database-2-line',
  },
];

export default function CapabilitiesSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <div className="w-10 h-px bg-accent-500/60 mx-auto mb-6"></div>
          <p className="text-sm tracking-widest uppercase text-foreground-500 font-label mb-4">
            Core Capabilities
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-light text-foreground-900">
            What We Bring to Every Project
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="group p-8 md:p-10 bg-background-50 border border-background-200/70 rounded-lg transition-colors duration-300 hover:border-accent-300/40"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100/80 mb-6">
                <i className={`${cap.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-medium text-foreground-900 mb-3">
                {cap.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-light">
                {cap.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}